import { IconButton } from 'component/Button/IconButton'
import { Img } from 'component/Image'
import { Modal } from 'component/Modal'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { itemRecommendations } from 'page/BasicInferenceScreen/ItemRecommendationsModal/ItemRecommendationsModalStore'
import { Fragment } from 'react'
import { ItemRecommendation } from 'type/ItemRecommendations'
import css from './ItemRecommendationsModal.module.scss'

/** Строка вида «Артикул: 123»: подпись серая, значение обычное — как в карточке товара на экране. */
const Field = ({ label, value }: { label: string, value: string }) => (
  <Space gap={6} top>
    <Typo size={16} tertiary nowrap>
      {label}
    </Typo>
    <Typo size={16} wrap>
      {value}
    </Typo>
  </Space>
)

const Item = ({ item }: { item: ItemRecommendation }) => {
  const { name, brand, article, price, image, description } = item

  return <Space className={css.item} gap={20} top>
    {image ? <Img className={css.image} src={image} /> : <div className={css.image} />}
    <Vertical gap={12} wide oh>
      {name && <Typo size={20} semi upper wrap>
        {name}
      </Typo>}
      <Vertical gap={2}>
        {article && <Field label={i18n('Articul')} value={article} />}
        {brand && <Field label={i18n('Brand')} value={brand} />}
        {description && <Field label={i18n('Description')} value={description} />}
      </Vertical>
      {price && <Typo size={18} semi>
        {price}
      </Typo>}
    </Vertical>
  </Space>
}

export const ItemRecommendationsModal = observer(() => {
  const { visible } = itemRecommendations

  const onClose = useLatestCallback(() => {
    itemRecommendations.hide()
  })

  return <Modal gap={0} width={640} round={24}>
    <Space gap={16} top>
      <Vertical gap={4} wide oh>
        <Typo size={28} medium>
          {i18n('CompleteTheLook')}
        </Typo>
        <Typo size={16} tertiary wrap>
          {i18n('CompleteTheLookHint')}
        </Typo>
      </Vertical>
      <IconButton size={56} action={onClose}>
        <Icon size={24} name="close" />
      </IconButton>
    </Space>

    <Vertical className={css.items} wide>
      {visible.map((item, index) => (<Fragment key={item.item_id ?? index}>
        {index > 0 && <Divider secondary />}
        <Item item={item} />
      </Fragment>))}
    </Vertical>
  </Modal>
})
